// @flow
import dispatchAsync from 'utils/dispatchAsync';
import type { ZuzuThunk, Comment, Like, SingleTopic } from 'types';

export type Topic = {
  topicId: string,
  title: string,
  description: string,
  images: Array<string>,
  createdBy: string,
  createdAt: number,
  comments: Array<Comment>,
  likes: Array<Like>,
};

export type LoadTopicsAction = {
  type: 'LOAD_TOPICS',
  payload?: Array<Topic>,
  meta: {
    done: boolean,
    error?: boolean,
  },
};
export const LOAD_TOPICS = 'LOAD_TOPICS';
export const loadTopics = (): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: LOAD_TOPICS,
    url: '/api/management/topic/all',
    method: 'get',
    dispatch,
    transform: payload => [
      ...payload.sort((a, b) => b.createdAt - a.createdAt),
    ],
  });

export type LoadSingleTopicAction = {
  type: 'LOAD_SINGLE_TOPIC',
  payload?: SingleTopic,
  meta: {
    done: boolean,
    error?: boolean,
  },
};
export const LOAD_SINGLE_TOPIC = 'LOAD_SINGLE_TOPIC';
export const loadSingleTopic = (topicId: string): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: LOAD_SINGLE_TOPIC,
    url: `/api/management/topic/single/${topicId}`,
    method: 'get',
    dispatch,
  });

export const CREATE_TOPIC = 'CREATE_TOPIC';
export const createTopic = (
  title: string,
  description: string,
  images: Array<string>,
  visibleIn: Array<string>
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: CREATE_TOPIC,
    url: '/api/management/topic',
    method: 'post',
    dispatch,
    body: {
      title,
      description,
      images,
      visibleIn,
    },
  });

export const COMMENT_TOPIC = 'COMMENT_TOPIC';
export const commentTopic = (
  topicId: string,
  text: string
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: COMMENT_TOPIC,
    url: '/api/management/topic/comment',
    method: 'post',
    dispatch,
    body: {
      topicId,
      text,
    },
  });

export const EDIT_COMMENT_TOPIC = 'EDIT_COMMENT_TOPIC';
export const editCommentTopic = (
  topicId: string,
  commentIndex: number,
  text: string
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: EDIT_COMMENT_TOPIC,
    url: '/api/management/topic/comment',
    method: 'put',
    dispatch,
    body: {
      topicId,
      commentIndex,
      text,
    },
  });

export const DELETE_TOPIC = 'DELETE_TOPIC';
export const deleteTopic = (
  topicId: string,
  reason: string
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: DELETE_TOPIC,
    url: '/api/management/topic/delete',
    method: 'post',
    body: {
      topicId,
      reason,
    },
    dispatch,
  });

export const EDIT_TOPIC = 'EDIT_TOPIC';
export const editTopic = (
  topicId: string,
  field: string,
  value: string
): ZuzuThunk => async dispatch =>
  dispatchAsync({
    type: EDIT_TOPIC,
    url: '/api/management/topic',
    method: 'put',
    body: {
      topicId,
      field,
      value,
    },
    dispatch,
  });



// WEBPACK FOOTER //
// ./src/redux/actions/topics.js